import { IPetItemResponse } from "../services/Standard-of-care/standard-of-care.interface";
import { MIXPANEL_EVENTS } from "../config/mixPanelEvents";
import { MODALS } from "../config/params";
import { useAppointmentStore } from "./redux-hooks/appointment-store/appointment.store";
import { useModal } from "../context/ModalContext";
import { useOverdueInvoiceStore } from "./redux-hooks/overdue-invoice-store/overdue-invoice.store";
import { usePetStore } from "./redux-hooks/pet-store/pet-store.service";
import { userActivityLogger } from "../utils/mixpanel";

export const useBookAppointment = (referredFrom: string) => {
  const { setSelectedPets } = useAppointmentStore();
  const { openModal } = useModal();
  const { petList } = usePetStore();
  const {
    pendingPaymentPetList,
    isBookingBlocked,
    pausedWellnessPetList,
    cancelledWellnessPetList,
  } = useOverdueInvoiceStore();

  const openSchedule = () => {
    if (!isBookingBlocked && pendingPaymentPetList.length > 0) {
      if (cancelledWellnessPetList.length > 0) {
        openModal(MODALS.PENDING_INVOICE_CANCELLED_ALERT_MODAL);
      } else if (pausedWellnessPetList.length > 0) {
        openModal(MODALS.PENDING_INVOICE_PAUSED_ALERT_MODAL);
      } else {
        openModal(MODALS.GENERIC_PAYMENT_ISSUE_MODAL);
      }
    } else {
      openModal(MODALS.UPDATED_BOOK_A_VISIT_MODAL);
    }
  };

  const bookAppointment = (petData: IPetItemResponse) => {
    if (!petData) {
      return;
    }

    setSelectedPets([petData]);
    userActivityLogger(MIXPANEL_EVENTS.BOOK_A_VISIT_SELECT_PET, {
      no_of_pets: 1,
      owner_type: petList?.length === 1 ? "single_pet" : "multipet",
      referred_from: referredFrom,
      appt_type: "in_room_visit",
    });
    openSchedule();
  };

  return { bookAppointment, isBookingBlocked };
};
